import useGet from './api/useGet'
import { onMounted } from 'vue'
import type { Skill } from '../models/skill'
import type { FeedbackTopic } from '../models/feedback-topic'
import { useStartSelfFeedback } from '@/modules/start-self-feedback/use-start-self-feedback'

export const useSuperpower = () => {
  const { status, data, load } = useGet<SuperpowerData>('member/superpower')

  onMounted(() => {
    load()
  })

  const { selfFeedbackFormData, startSelfFeedback, clearForm } = useStartSelfFeedback()
  const startSuperpowerSurvey = async () => {
    if (data.value.superpowerTopic) {
      selfFeedbackFormData.templateIds = [data.value.superpowerTopic.id]
      await startSelfFeedback()
      clearForm()
    }
  }

  return {
    status,
    data,
    startSuperpowerSurvey,
  }
}

export interface SuperpowerData {
  superpowerTopic?: FeedbackTopic
  superpower: Skill | null
}
